<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible="visible"
    width="950px"
    :title="title"
    :close-on-click-modal="false"
    :before-close="() => close()"
    :modal-append-to-body="false"
    :modal="false"
    append-to-body
    v-el-dialog-drag
  >
    <el-row :gutter="25">
      <el-col :span="12">
        <div class="side_frame_warning">
          <el-card shadow="never" style="background-color: #FFF6F7;border:0px">
            <div slot="header">
              <span class="span_text_header">{{
                $l('form_label_operation_tips') || '操作提示'
              }}</span>
            </div>
            <div class="span_text_body">
              {{
                $l('tips_batch_update_nc_one') ||
                  '请按“赋码导出”功能，导出的Excel文件中产品显示顺序，将NC系统生成好的物料编码，粘贴在右侧的输入框中。'
              }}
            </div>
            <br />
            <br />
            <div class="span_text_body">
              {{
                $l('tips_batch_update_nc_two') ||
                  '每行输入一个物料编码，并对应系统订单中对应产品，多个物料编码请使用回车进行换行。'
              }}
            </div>
            <br />
            <br />
            <div class="span_text_body" style="margin-bottom: 7px;">
              {{
                $l('tips_batch_update_nc_three') ||
                  '点击“更新”按钮，将本次粘贴的物料编码，更新到订单对应产品中。'
              }}
            </div>
          </el-card>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="side_frame_pri">
          <el-card shadow="never" style="background-color: #ECF8FF;border:0px">
            <div slot="header">
              <span class="span_text_header">{{
                $l('form_label_paste_the_material_code') || '粘贴物料编码'
              }}</span>
            </div>
            <div class="span_text_body">
              <el-input
                v-model="ncNo"
                type="textarea"
                clearable
                size="small"
                rows="11"
              >
              </el-input>
            </div>
          </el-card></div
      ></el-col>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="close">
        {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
      </el-button>

      <el-button size="small" type="primary" @click="batchUpdate">
        {{ $l('form_label_batch_updates') || '批量更新' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'

export default {
  mixins: [EditLoading],
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '批量更新NC编码' },
    noticeOrderCode: { type: String, default: '' },
  },
  data() {
    return { ncNo: '' }
  },

  methods: {
    close() {
      this.$emit('update:visible', false)
    },
    async batchUpdate() {
      const ncNoList = this.ncNo.split('\n') || []
      if (!this.ncNo || !ncNoList || !ncNoList.length) {
        this.$message.warning(
          this.$l('form_label_please_paste_the_material_code') ||
            '请粘贴物料编码'
        )
        return
      }
      const ncNoSize = ncNoList.filter((i) => i.length > 50)
      if (!ncNoSize || ncNoSize.length) {
        this.$message.error(
          this.$l('tips_the_length_exceed_50') ||
            '单条物料编码长度不能大于50,请检查后重试'
        )
        return
      }

      this.loading = true
      this.$api
        .noticeOrderSetNcApi({
          ncNoList,
          noticeOrderCode: this.noticeOrderCode,
        })
        .then((res) => {
          this.loading = false
          const { status } = res
          if (status == 200) {
            this.$message({
              message: this.$l('INDEX.tips_save_ok') || '保存成功',
              type: 'success',
            })
            this.close()
            this.$emit('confirm')
          }
        })
        .catch(() => {
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
          this.loading = false
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.side_frame_warning {
  border-left: 4px solid #fe6c6f;
  margin: 15px 0;
  border-radius: 4px;
}
.side_frame_pri {
  border-left: 4px solid #50bfff;
  margin: 15px 0;
  border-radius: 4px;
}
::v-deep .el-card__header {
  padding: 8px 8px;
  border-bottom: 0px;
}
::v-deep .el-card__body {
  padding: 10px;
}

.span_text_header {
  font-weight: 700;
  font-size: 18px;
}
.span_text_body {
  font-weight: 700;
  font-size: 15px;
}
</style>
